<template>
  <div class="login">
    <brave-form action="https://www.bravenet.com/login.php" v-bind="form" :validate="validate" :sending="sending">
      <md-card class="md-flex-100 md-flex-small-100">
        <md-card-header>
          <noscript>
            <div style="margin-bottom: 20px;"class="error-container">
              We have detected that you do not have Javascript enabled, <a class="underline" href="https://www.enable-javascript.com/" target="_blank">please enable Javascript</a> to experience the full functionality of Bravenet.<br/>
            </div>
          </noscript>
          <div class="md-title">Login to your Account</div>
          

          
          <div class="header-helper">
            Don't have a Bravenet account?
            <a v-if="asModal == true" class="underline accent" @click="swapToRegister">Register</a>
            <router-link v-else :to="{path: '/register', query}" class="underline accent">Register</router-link>
          </div>
          <section v-for="(content, name) in errors" :key="name">
            <div class="error-container" v-if="content">
              <div v-if="name === 'serverMessage'" v-html="content"></div>
              <div v-else v-html="$t(`login.ERROR_${name.toUpperCase()}`)"></div>
            </div>
          </section>

        </md-card-header>
        <md-card-content>
          <div class="md-layout-row md-layout-wrap md-gutter">
            <div class="md-flex md-flex-small-100">
              <noscript>
                <label for="userid">Username</label>
              </noscript>
              <md-field :class="getValidationClass('userid')">
                <label v-if="nojs == false" for="userid">Username</label>
                <md-input :style="{fontSize: (nojs) ? '14px' : ''}" name="userid" id="userid" v-model="form.userid" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.userid.required">Your Username is required</span>
                <span class="md-error" v-if="!$v.form.userid.isemail">You must login with your username</span>
                <span class="md-error" v-else-if="!$v.form.userid.minlength">Invalid Username</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout-row md-layout-wrap md-gutter">
            <div class="md-flex md-flex-small-100">
              <noscript>
                <label for="password">Password</label>
              </noscript>
              <password-field
                id="password"
                name="password"
                v-model="form.password"
                :disabled="sending"
                :field-class="getValidationClass('password')"
                :nojs="nojs"
                :input-style="{fontSize: (nojs) ? '14px' : ''}"
              >
                <label v-if="nojs == false" for="password" slot="label">Password</label>
                <span class="md-error" v-if="!$v.form.password.required">Your Password is required</span>
                <span class="md-error" v-if="!$v.form.password.minlength">Invalid Password</span>
              </password-field>
            </div>
          </div>

          <div class="md-layout-row md-layout-wrap md-gutter">
            <div class="md-layout-row md-gutter md-layout-wrap">
              <div class="md-flex md-flex-small-100">
                <label class="remember-me" for="rememberme">
                  <input
                    id="rememberme"
                    type="checkbox"
                    name="rememberme"
                    value="1"
                    v-model="form.rememberme"
                    :disabled="sending"
                  />
                  <span>Remember Me</span>
                </label>
              </div>
            </div>
          </div>
          <input type="hidden" name="nojs" value="true"/>

          <div v-if="captchaRequired" class="md-layout-row md-layout-wrap md-gutter">
            <div class="md-flex md-flex-small-100">
              <altcha ref="recaptcha" />
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <md-button
            type="submit"
            class="md-accent md-raised"
            :disabled="sending">Login</md-button>
        </md-card-actions>

      </md-card>
      <div class="helper-links">
        <template v-if="asModal == true">
          <a class="accent" @click="swapToRegister">Need an account?</a>
          <a class="accent" @click="swapToLostPassword">Forgot your password?</a>
        </template>
        <template v-else>
          <router-link class="accent" :to="{path: '/lostpassword', query}">Forgot your password?</router-link>
          <a class="accent" href="https://www.bravenet.com/help/">Need help?</a>

        </template>

      </div>

    </brave-form>

  </div>
</template>

<script>
  import Vue from 'vue'
  import QueryString from 'brave-utils/query-string'
  import FormExtension from 'brave-form/components/extension'
  import BravenetAPI from 'brave-api/bravenet'
  import { HOSTING_CHECKOUT_URL } from 'brave-api/constants'
  import style from 'brave-authentication/components/login-register.scss'
  import securityUpgrade from 'brave-authentication/components/security-upgrade'
  import register from 'brave-authentication/components/register'
  import lostpassword from 'brave-authentication/components/lostpassword'
  import { validationMixin } from 'vuelidate'
  import altcha from 'brave-authentication/components/altcha'
  import passwordField from 'brave-authentication/components/password-field'

  import {
    required,
    email,
    minLength,
    maxLength,
  } from 'vuelidate/lib/validators'

  let isEmail = (value) => (value!==null) ? value.indexOf('@') == -1 : false

  export default {
    extends: FormExtension,
    name: 'LoginForm',
    components: {
      altcha,
      passwordField
    },
    data: () => {
      let qs = new QueryString(window.location.search)
      let params = qs.toSingleValueDict()
      let from = (params.from)
        ? params.from
        : null
      let to = (params.redirect_to)
        ? params.redirect_to
        : null

      let cart_hash = (params.cart_hash)

      let query = (from)
        ? { from: from }
        : (cart_hash) ? { cart_hash: cart_hash } : {}
      if (to) {
        query.redirect_to = to
      }

      if(params.template_id!==undefined) {
          query.template_id = params.template_id
      }
      
      if(params.type!==undefined) {
          query.type = params.type
      }

      return {
        form: {
          userid: null,
          password: null,
          rememberme: false,
        },
        errors: {
          cookie: false,
          unexpected: false,
          authentication: false,
          locked: false,
          serverMessage: false
        },
        captchaRequired: false,
        query,
        nojs: (/PRERENDER/.test(window.navigator.userAgent))
      }
    },
    validations: {
      form: {
        userid: {
          required,
          minLength: minLength(1),
          isemail: isEmail
        },
        password: {
          required,
          minLength: minLength(3)
        }
      }
    },
    mounted() {
      var el = this.$el
      setTimeout(function () {
        $(el).find('input').trigger('change')
      }, 20)
    },
    methods: {
      clearForm () {
        this.form.userid = null
        this.form.password = null
        this.form.rememberme = false
      },
      async onSubmit () {
        this.$v.$touch()

        if (this.$v.$invalid) {
          this.formSubmitStatus = 'error'
          return
        }

        if (this.captchaRequired) {
          const captchaComponent = this.$refs.recaptcha;
          if (!captchaComponent || !captchaComponent.value) {
            this.errors.authentication = false;
            this.errors.serverMessage = 'Please complete the security verification before submitting.';
            console.warn('Login attempt blocked: ALTCHA token missing.', {
              component: captchaComponent ? 'exists' : 'missing',
              value: captchaComponent ? captchaComponent.value : null
            });
            this.sending = false;
            return;
          }
          console.log('ALTCHA: Submitting login with token:', captchaComponent.value ? 'Token present' : 'Token missing');
        }

        this.sending = true
        this.errors.authentication = false
        for (let error of (Object.keys(this.errors))) {
          this.errors[error] = false
        }
        let payload = Object.assign({}, this.form)
        if (this.captchaRequired) {
          payload['altcha'] = this.$refs.recaptcha.value
        }
        let data = await BravenetAPI.login(payload)

        this.form.rememberme = (this.form.rememberme) ? true:false

        if (data.status === "ERROR") {
          switch (data.response.reason) {
            case 'AUTHENTICATION_FAILED':
              this.errors.authentication = true
              break;
            case 'COOKIES_REQUIRED':
              this.errors.cookie = true
              break;
            case 'ACCOUNT_LOCKED':
              this.errors.locked = true
              break;
            case 'SECURITY_UPGRADE':
              this.$store.dispatch('pushModal', {
                component: securityUpgrade,
                props: {
                  suspiciousEmail: data.response.emailAddress
                }
              })
              break;
            default:
              this.errors.unexpected = true
              break;
          }

          this.afterSubmit()
        } else if (data.status === "SUCCESS") {
          if (this.asModal) {
            this.onSuccess(data)
          } else {
            // Use props type if available, otherwise fall back to query type
            const typeToInclude = this.type || this.query.type
            
            // If we have a type parameter, redirect to hosting checkout (mimicking modal behavior)
            if (typeToInclude) {
              let redirectUrl = HOSTING_CHECKOUT_URL.replace('$CURRENT_PUB$', data.response.pub)
              let queryString = `?pickItem=${typeToInclude}`
              window.location.assign(`${redirectUrl}${queryString}`)
            } else {
              // Default behavior - use API redirect
              let redirectUrl = data.response.redirect
              if (redirectUrl.indexOf('?') !== -1) {
                redirectUrl = `${redirectUrl}&braveui=1${this.query.template_id ? `&template_id=${this.query.template_id}` : ''}`
              } else {
                redirectUrl = `${redirectUrl}?braveui=1${this.query.template_id ? `&template_id=${this.query.template_id}` : ''}`
              }
              window.location.assign(redirectUrl)
            }
          }
        } else {
          this.errors.unexpected = true
          this.afterSubmit()
        }
        if (this.$refs.recaptcha) {
          this.$refs.recaptcha.resetRecaptcha();
        }
        this.sending = false;
      },
      swapToRegister () {
        // Use props type if available, otherwise fall back to query type
        const typeToPass = this.type || this.query.type
        
        this.$store.dispatch('popModal')
        this.$store.dispatch('pushModal', {component: register, props: {onSuccess: this.onSuccess, from: this.from, template_id: this.template_id, type: typeToPass}})
      },
      swapToLostPassword () {
        this.$store.dispatch('popModal')
        this.$store.dispatch('pushModal', {component: lostpassword, props: {onSuccess: this.onSuccess, from: this.from}})
      }
    },
    props: ['asModal', 'onSuccess', 'from', 'template_id', 'type']
  }
</script>
